module.exports = __webpack_public_path__ + "img/ups.a8d17453.svg";